let form = $('.form');
var nome;
var tipo;
var valore;
var confronto_email;
var confronto_pass;
var errore;
let _this;
var required;
var accordion = $('.accordion');
var panel = $('.panel');
let warning_modal = $('.warning--modal-container');
let close_warning = $('.close-warning');

export function init() {
	$('.is-check > input').on('click', function(){
		$(this).closest('.not-visible-check').toggleClass('is-visible-check');
	});

	$('.btn-send').not('.btn-empty').on( 'click' , checkForm );
	$('.btn-empty').on( 'click' , cancel );

	close_warning.on('click', hideWarning);

	accordion.on('click', toggleAccordition);
}

let hideWarning = function(event) {
	warning_modal.hide();
	warning_modal.addClass('already-saw');
}

function toggleAccordition(event){
	const el = $( event.currentTarget );
	const target = $( '#' + el.attr( 'aria-controls' ) );

	if( el.hasClass('clicked') ){
		panel.removeClass('is-active');
		el.removeClass('clicked');
	}else{
		accordion.removeClass('clicked');
		el.addClass('clicked');
		panel.removeClass( 'is-active' );
		target.addClass( 'is-active' );
	}
}

function checkForm() {
	errore = 0;
	if($('.is-check > input').is(':checked')){
		required = form.find('.input__required');
	}else{
		required = form.find('.input__required').not('.not-visible-check .input__required');
	}

	required.each(function(){
		_this = $(this);

		_this.removeClass('input__error');
		_this.closest('span').removeClass('input__check-error');
		_this.parent().find('a').removeClass('input__check-error');

		nome = _this.attr('name');
		tipo = _this.attr('type');
		valore = _this.val();

		if (_this.data('otherwise')) {
			let _other = form.find('.input__field[name="' + _this.data('otherwise') + '"]');
			let _otherValore = _other.val();

			let checkThisValore = (valore == '' && valore.replace(' ', '') == '');
			let checkOtherValore = (_otherValore == '' && _otherValore.replace(' ', '') == '');

			if ((checkThisValore && checkOtherValore)) {
				errore = 1;

				if (checkThisValore) {
					_this.addClass('input__error');
				}
			}
		} else if(tipo == 'text'){
			if(valore == '' && valore.replace(' ', '') == '' ){
				errore= 1;
				_this.addClass('input__error');
			}
		}else if(tipo == 'number'){
			if(valore == '' && valore.replace(' ', '') == '' && !$.isNumeric(valore)){
				errore= 1;
				_this.addClass('input__error');
			}
		}else if(tipo == 'email'){
			if(isEmail(valore)){
				if(nome == 'acc_mail'){
					confronto_email= valore;
				}else if(nome == 'acc_conferma_mail'){
					if( confronto_email != valore ){
						_this.addClass('input__error');
						errore= 1;
					}
				}
			}else{
				_this.addClass('input__error');
				errore=1;
			}
		}else if(tipo == 'password'){
			if(valore.length >= 8){
				if(nome == 'acc_pass'){
					confronto_pass= valore;
				}else if(nome == 'acc_conferma_pass'){
					if( confronto_pass != valore ){
						_this.addClass('input__error');
						errore= 1;
					}
				}
			}else{
				_this.addClass('input__error');
				errore=1;
			}
		}else if(tipo == 'checkbox'){
			if(!_this.is(':checked')){
				_this.closest('span').addClass('input__check-error');
				_this.parent().find('a').addClass('input__check-error');
				errore= 1;
			}
		}
	});

	if (errore == 0) {
		form.submit();
	}

}

function cancel(){
	location.reload();
}

function isEmail(email) {
	var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	return regex.test(email);
}



// WEBPACK FOOTER //
// ./src/js/modules/registration.js